import { TFunction } from "i18next";

/**
 * ------
 * getDefMilestoneTranslation
 * 
 *  ------------
 * 🍀 USAGE
 * ```ts
 * const { t } = useTranslation();
 * const defMilestoneTranslation = getDefMilestoneTranslation(t);
 * const label = defMilestoneTranslation[Number(milestone.milestone_id)]?.label;
 * ```
 * ------------
 * 
 * @param number milestone id (default milestone id's 1-4) 
 * @returns a translated string for default milestones
 */
export const getDefMilestoneTranslation = (t: TFunction): Record<number, { label: string }> => ({
  1: { label: t("milestones.defaultMilestones.insemination", {defaultValue: "Insemination"}) },
  2: { label: t("milestones.defaultMilestones.farrowing", {defaultValue: "Farrowing"}) },
  3: { label: t("milestones.defaultMilestones.weaning", {defaultValue: "Weaning"}) },
  4: { label: t("milestones.defaultMilestones.movedToFarrowing", {defaultValue: "Moved To Farrowing"}) },
});